import React from 'react';
import { useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';

function CallStatus() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (pathname === '/call-status') {
      navigate('/call-status/did-not-answer', {
        replace: true,
      });
    }
  }, [navigate, pathname]);
  return (
    <main className="mytasks">
      <div className="selectors">
        <NavLink to="/call-status/did-not-answer">Did Not Answer</NavLink>
        <NavLink to="/call-status/do-not-call">Do Not Call</NavLink>
        <NavLink to="/call-status/not-interested">Not Interested</NavLink>
      </div>
      <Outlet />
    </main>
  );
}

export default CallStatus;
